/**
 * Created by JurY on 16/06/17.
 */

angular.module("screensApp")

  .controller("MatchtrackerController", function ($scope, $rootScope) {
    $scope.sendControllableMTElements = function () {
      var contentToControl = new Object({
        tabs: {
          type: "tabs",
          selector: ".sr-lmt-plus-tabs",
          findSelector: "button",
          selected: [],
        },
        arrows: {
          type: "arrows",
          selector: ".srm-notLmt .sr-scrollbars__container",
          findSelector: ">div",
          selected: {
            up: {
              icon: "ui-icon-main arr-up",
              index: 0,
              shift: -100,
            },
            down: {
              icon: "ui-icon-main arr-down",
              index: 1,
              shift: 100,
            }
          }
        }
      });

      // For every MT statistics, it pushes statistics name with index to array
      $(contentToControl.tabs.selector)
        .find(contentToControl.tabs.findSelector)
        .each(function (index, element) {
          var mainTab = {
            tabIndex: index,
            tabText: $(element).text(),
            selector: ".sr-general-statistics-periods__inner-wrapper",
            findSelector: ".sr-general-statistics-periods__period",
            type: "subTabs",
            subTabs: [], // Create an array for subTabs
          };

          var subTabElements = $("#matchTrackerGeneralStatistics").find(".sr-general-statistics-periods__inner-wrapper .sr-general-statistics-periods__period");

          if ($(element).attr("data-test-tab") === "statistics") {
            // If it's the first tab, add subTabs to the selected tab
            var selectClass;
            subTabElements.each(function (subTabIndex, subTabElement) {
              if ($(subTabElement).find(".sr-general-statistics-periods__period-name-long").is(":visible")) {
                selectClass = $(subTabElement).find(".sr-general-statistics-periods__period-name-long").text();
              } else {
                selectClass = $(subTabElement).find(".sr-general-statistics-periods__period-name-short").text();
              }
              var subTab = {
                tabIndex: subTabIndex,
                tabText: selectClass,
              };
              mainTab.subTabs.push(subTab);
            });
          }

          contentToControl.tabs.selected.push(mainTab);
        });

      $rootScope.BottomScreen("matchTrackerControllable", { ...contentToControl, initiator: "screensApp" });
      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: sendControllableMTElements { matchTrackerControllable } contentToControl: ' + JSON.stringify(contentToControl));
    };

    $rootScope.matchTrackerControlExecute = function (data) {
      if (data) {
        var actionElement = $(data.selector).find(data.findSelector);
        switch (data.type) {
          case "tabs":
            actionElement[data.selected].click();
            setTimeout(function () {
              if ((expander = $(".sr-lmt-plus-pbp-period__expand-header").not(".srm-is-open")) && expander.length) {
                // expand collapsed divs (timeline)
                expander.trigger("click");
              }
            }, 1000);
            break;
          case "subTabs":
            actionElement[data.selected].click();
            break;
          case "arrows":
            actionElement.each(function (el, aElement) {
              // check all divs to scroll
              if ($(aElement).prop("scrollHeight") > $(aElement).height()) {
                $rootScope.checkScroll(aElement, null, data.selected, 200);
              }
            });
            $.each([$(".sr-lmt-plus__comp.srm-double.srm-notLmt"), $("#matchTrackerGeneralStatistics")], function (s, scrollElement) {
              $rootScope.checkScroll(scrollElement, null, data.selected, 200);
            });
            break;
          default:
            break;
        }
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: matchTrackerControlExecute { matchTrackerControllable } data: ' + JSON.stringify(data));
        $rootScope.$$phase || $rootScope.$apply();
      } else {
        return false;
      }
    };

    // Hide Matchtracker
    $rootScope.hideMatchtracker = function () {
      if ($rootScope.matchTrackerElement) {
        $scope.eventID = null;

        $rootScope.settings.matchTracker.show = false;
        $rootScope.createLogForStreamMedia("MT", $rootScope.settings.matchTracker.show);
        SIR("removeWidget", $rootScope.matchTrackerElement);
        SIR("removeWidget", $rootScope.matchTrackerGeneralStatisticsElement);

        $rootScope.$$phase || $rootScope.$apply();
      }
    };

    ($rootScope.showMatchtracker = function (data) {
      if (data.eventID && $scope.eventID !== data.eventID) {
        $scope.eventID = data.eventID;
        $rootScope.matchTrackerElement = "#matchtracker";
        $rootScope.matchTrackerGeneralStatisticsElement = "#matchTrackerGeneralStatistics";
        var generalStatisticsWidget = $($rootScope.matchTrackerGeneralStatisticsElement);
        var generalStatisticsLoaded = false;

        if (!generalStatisticsLoaded) {
          var loadGeneralStatisticsPromise = new Promise(function (resolve) {
            SIR("addWidget", $rootScope.matchTrackerGeneralStatisticsElement, "match.generalStatistics", { matchId: data.eventID }, function () {
              generalStatisticsWidget.hide();
              resolve();
            });
          });

          // Set the flag to true after loading the general statistics.
          loadGeneralStatisticsPromise.then(function () {
            generalStatisticsLoaded = true;
          });
        }

        var loadMatchtrackerPromise = new Promise(function (resolve) {
          SIR("addWidget", $rootScope.matchTrackerElement, "match.lmtPlus", { disableWidgetHeader: true, layout: "double", scoreboard: "extended", momentum: "extended", tabsPosition: "top", collapseTo: "pitch", logoLink: "https://www.doxxbet.sk/sk", matchId: data.eventID }, function () {
            resolve();
          });
        });

        Promise.all([loadGeneralStatisticsPromise, loadMatchtrackerPromise]).then(function () {
          setTimeout(function () {
            $scope.sendControllableMTElements();
            var firstTabButton = $("#matchtracker .sr-lmt-plus-tabs .sr-tabs-tab__wrapper:first");
            generalStatisticsWidget.show();
            if (firstTabButton.length) {
              firstTabButton.on("click", function () {
                generalStatisticsWidget.show();
              });
            }

            $("#matchtracker .sr-lmt-plus-tabs .sr-tabs-tab__wrapper:not(:first)").on("click", function () {
              generalStatisticsWidget.hide();
            });

            setTimeout(function () {
              // During iframe first loading single arrows are send, it needs time to full load statistics when slow Network, ...
              $scope.sendControllableMTElements();
            }, 2000);
          }, 1000);
        });

        $rootScope.settings.matchTracker.show = true;

        $rootScope.createLogForStreamMedia("MT", $rootScope.settings.matchTracker.show);
        $rootScope.$$phase || $rootScope.$apply();
      }
    }),
      function (err) {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: matchtracker err: ' + err);
        $rootScope.hideMatchtracker();
      };
  });
